import {nextTick, ref} from 'vue';

export const internalNotificationPath = (url, origin = window.location.origin) => {
  try {
    const parsed = new URL(url, origin);
    if (parsed.origin !== origin || !['http:', 'https:'].includes(parsed.protocol)) {
      return null;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (error) {
    return null;
  }
};

export const useAppNotification = () => {
  const current = ref(null);
  const pending = ref(null);
  const visible = ref(false);

  const show = async (notification) => {
    if (current.value !== null) {
      pending.value = notification;
      visible.value = false;
      return;
    }
    current.value = notification;
    await nextTick();
    visible.value = true;
  };

  const close = () => {
    visible.value = false;
  };

  const afterLeave = async () => {
    current.value = pending.value;
    pending.value = null;
    if (current.value !== null) {
      await nextTick();
      visible.value = true;
    }
  };

  return {current, visible, show, close, afterLeave};
};
